import { render } from "./Messenger.vue?vue&type=template&id=23b7d4b7"
const script = {}
script.render = render

export default script